import React, { useState } from "react";
import { validate } from "../../utils/validate";
import { db } from "../../utils/firebase";

const initForm = {
	firstname: "",
	lastname: "",
	email: "",
	message: ""
};
const ContactUs = () => {
	const [form, setForm] = useState(initForm);
	const [formerrors, setformErrors] = useState(initForm);
	const [success, setSuccess] = useState(false);
	const [sending, setSending] = useState(false);
	const [error, setError] = useState("");
	const handleChange = e => {
		setForm({ ...form, [e.target.name]: e.target.value });
	};
	const handleSubmit = e => {
		e.preventDefault();
		console.log(form);
		//validate
		const { errors, isValid } = validate(form);
		console.log(errors);
		//send email from cloud functions
		if (isValid) {
			setSending(true);
			//store in the firestore
			db.collection("contacts")
				.add(form)
				.then(snapshot => {
					setSending(false);
					setSuccess(true);
				})
				.catch(e => {
					setError(e.message);
				});
		} else {
			setformErrors(errors);
		}

		//setSuccess
	};

	return (
		<div className="contact_wrapper">
			{success && <h1>Thank You :)</h1>}
			{!success && (
				<>
					<h1>Contact Me </h1>
					{error && <span className="error send_error">{error}</span>}
					<form className="contact_form" onSubmit={handleSubmit}>
						<div className="cf_details">
							<input
								type="text"
								name="firstname"
								placeholder="First name.."
								onChange={handleChange}
							/>
							{formerrors.firstname && (
								<span className="error">
									Please enter first name{" "}
								</span>
							)}
							<input
								type="text"
								name="lastname"
								placeholder="Last name.."
								onChange={handleChange}
							/>
							{formerrors.lastname && (
								<span className="error">
									Please enter second name{" "}
								</span>
							)}
							<input
								type="email"
								name="email"
								placeholder="Email here.."
								onChange={handleChange}
							/>
							{formerrors.email && (
								<span className="error">
									Please enter an valid email{" "}
								</span>
							)}
						</div>
						<div className="cf_message">
							<textarea
								onChange={handleChange}
								name="message"
								className="message"
								placeholder="message..."
							></textarea>
							{formerrors.message && (
								<span className="error">
									Please write a message{" "}
								</span>
							)}
						</div>
						<div className="cf_submit_wrapper">
							<input
								type="submit"
								value={sending ? "Sending..." : "Send Message"}
								disabled={sending}
							/>
						</div>
					</form>
				</>
			)}
		</div>
	);
};

export default ContactUs;
